import {
    OfficeViewCallRecording,
    OfficeViewCallResults,
    OfficeViewMiddleHeader,
} from "dyl-components";
import React from "react";
import { useSelector } from "react-redux";

const EditCall = ({
    control,
    editLogModal,
    onSave,
    onEmailClick,
    onTaskClick,
    onEventClick,
    onHotlistClick,
    onSaveDisabled,
    isInHotlist,
}) => {
    const call = editLogModal?.data;
    const { activeIntegration, isUpdatingCallResults } = useSelector(
        (state) => {
            return {
                isUpdatingCallResults:
                    state?.call_history.isUpdatingCallResults,
                activeIntegration: state?.oauth_integrations?.activeIntegration,
            };
        }
    );

    return (
        <div
            className="OfficeView__midContainer"
            style={{ marginTop: "-3rem" }}
        >
            <OfficeViewMiddleHeader
                person={{
                    name: call?.record?.name,
                    contact_id: call?.record?.contact_id,
                    account_id: call?.record?.account_id,
                    contact_details: {
                        email: call?.record?.email,
                        job_title: call?.record?.job_title,
                        pipeline_stage: "opportunity",
                    },
                    account_details: {
                        account_type: call?.record?.contact_type,
                        customer: call?.record?.is_customer,
                    },
                }}
                unknown={{
                    unknown: !call?.record?.name,
                    name: call?.record?.name,
                }}
                onRemovePerson={editLogModal.closeModal}
                isInHotlist={isInHotlist}
                hasIntegration={Object.keys(activeIntegration || {}).length > 0}
                onEmailClick={onEmailClick}
                onTaskClick={onTaskClick}
                onEventClick={onEventClick}
                onHotlistClick={onHotlistClick}
            />
            <OfficeViewCallRecording
                currentCallPhoneNumber={call?.phone}
                duration={call?.length}
                callRecording={{
                    url: call?.call_recording,
                    sound_id: call?.call_uuid,
                }}
            />

            <OfficeViewCallResults
                control={control}
                callResultsDisabled={call?.direction !== "outbound"}
                onSave={onSave}
                onSaveDisabled={onSaveDisabled}
                isSaveLoading={isUpdatingCallResults}
            />
        </div>
    );
};

export default EditCall;
